import { useEffect } from "react";

import { useAppContext } from "./AppContext";

function ResetScrollOnStepChange({ children }) {
  const { currentStep } = useAppContext();

  useEffect(() => {
    window.scroll(0, 0);
  }, [currentStep]);

  return children;
}

export default ResetScrollOnStepChange;
